import React, { Suspense, useEffect, lazy } from 'react'
import { Route, Routes, BrowserRouter, useNavigate, useLocation } from 'react-router-dom';
import 'styles/common.scss';
import 'styles/_variables.scss';
import 'styles/_mixin.scss';
import 'styles/reset.scss'
import 'styles/index.css'

import axios from 'axios';
import Auth from 'utils/auth';
import packageJson from '../package.json';
import { useDispatch } from 'react-redux';
import { SidebarProvider } from "components/ui/sidebar"
import { AnalyticsProvider } from './provider/AnalyticsProvider';
import ReactGA from 'react-ga4';

const EclinicEvent = lazy(() => import('pages/eclinic-event/EclinicEvent'))
const EclinicSpecialEvent = lazy(() => import('pages/eclinic-special-event/EclinicEvent'))
const LayviewPrivacy = lazy(() => import('pages/layview-privacy/LayviewPrivacy'))

global.appVersion = packageJson.version;

// const loading = <Load isBg />;
function App() {

    return (
        <>
            <BrowserRouter>
                <Suspense >
                    <AnalyticsProvider trackingId={'G-XQG8W8DHD9'} debug={false}>
                        <Routes>
                            {/* <Route path="/main" element={<Main />} /> */}
                            <Route path="/eclinicEvent" element={<EclinicEvent />} />
                            <Route path="/eclinicSpecialEvent" element={<EclinicSpecialEvent />} />
                            <Route path="/privacy" element={<LayviewPrivacy />} />
                        </Routes>
                    </AnalyticsProvider>
                </Suspense>
            </BrowserRouter>

        </>
    );
}

export default App;
